// import { stringify } from 'qs';
import request from '../utils/request';

export async function accountLogin(params) {
  const host =  process.env.X_PARTNER_HOST || 'office.urbox.vn'
  console.log("X_PARTNER_HOST",host)
  return request('v1/api/user/login-username', {
    method: 'POST',
    body: params,
    headers: {
      'x-partner-host': host
    }
  });
}

export async function accountLoginCaptcha(params) {
  const captchaToken = params.token;
  delete params.token;
  return request('/user/login-username/captcha', {
    method: 'POST',
    body: params,
    headers: {
      'x-captcha-token': captchaToken
    }
  });
}

export async function register(params) {
  return request('/register', {
    method: 'POST',
    body: params,
  });
}

export async function logoutService(params) {
  return request('/user/logout', {
    method: 'POST',
    body: params,
  });
}

export async function getCaptcha(mobile) {
  return request(`/captcha?mobile=${mobile}`);
}
